var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
/* eslint react/prop-types: 0 */
import React from 'react';
import { map } from 'ramda';
import RenderDetail from './RenderDetail';
import SeverityScoreDisplay from './SeverityScoreDisplay';
function renderScore(severityScore) {
    return React.createElement(SeverityScoreDisplay, { key: severityScore.source, severityScore: severityScore });
}
var SeverityDetail = function SeverityDetail(_a) {
    var mainSeverity = _a.mainSeverity, severityScores = _a.severityScores;
    var compoundedSeverities = mainSeverity
        ? __spreadArrays([mainSeverity], (severityScores || [])) : __spreadArrays((severityScores || []));
    return compoundedSeverities && compoundedSeverities.length ? (React.createElement(RenderDetail, { title: "Severity" },
        React.createElement("dl", null, map(renderScore, compoundedSeverities)))) : null;
};
export default SeverityDetail;
//# sourceMappingURL=SeverityDetail.js.map